// Treasury accounts parser — DTO (wire shape) → view model. The seam
// every consumer must respect. Containers / components / composables
// never read a snake_case field directly.

import type {
  TreasuryBankAccountDetailDto,
  TreasuryBankAccountDto,
} from './treasuryAccountsContracts'
import type { TreasuryBankAccount, TreasuryBankAccountDetail } from '../types/treasuryAccountsTypes'

export function parseTreasuryBankAccount(dto: TreasuryBankAccountDto): TreasuryBankAccount {
  return {
    id: String(dto.id ?? ''),
    accountName: String(dto.accountName ?? dto.account_name ?? ''),
    bankName: String(dto.bankName ?? dto.bank_name ?? ''),
    currencyCode: String(dto.currencyCode ?? dto.currency_code ?? ''),
    countryCode: String(dto.countryCode ?? dto.country_code ?? ''),
    status: dto.status,
    isDefault: Boolean(dto.isDefault ?? dto.is_default ?? false),
  }
}

export function parseTreasuryBankAccountDetail(
  dto: TreasuryBankAccountDetailDto,
): TreasuryBankAccountDetail {
  return {
    id: String(dto.id ?? ''),
    accountName: String(dto.accountName ?? dto.account_name ?? ''),
    bankName: String(dto.bankName ?? dto.bank_name ?? ''),
    accountNumber: String(dto.accountNumber ?? dto.account_number ?? ''),
    iban: dto.iban ?? null,
    swiftBic: dto.swiftBic ?? dto.swift_bic ?? null,
    currencyCode: String(dto.currencyCode ?? dto.currency_code ?? ''),
    countryCode: String(dto.countryCode ?? dto.country_code ?? ''),
    status: dto.status,
    isDefault: Boolean(dto.isDefault ?? dto.is_default ?? false),
    notes: dto.notes ?? null,
    createdAt: String(dto.createdAt ?? dto.created_at ?? ''),
    updatedAt: String(dto.updatedAt ?? dto.updated_at ?? ''),
  }
}
